export const POST_LIKE_TYPE_LIKE = 'like';
